import { extractYouTubeVideoId as extractYouTubeVideoIdFromUrl } from '@domain/features/youtube/youtube-url'

export function isUpcomingWebinar(webinarDate: Date): boolean {
  return webinarDate.getTime() > Date.now()
}

export function formatWebinarDate(webinarDate: Date): string {
  return webinarDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export function formatWebinarDateTime(
  webinarDate: Date,
  webinarTime?: string,
  timeZone?: string,
): string {
  const dateLabel = formatWebinarDate(webinarDate)
  const timeLabel = webinarTime?.trim()
  const timeZoneLabel = timeZone?.trim()

  if (!timeLabel && !timeZoneLabel) {
    return dateLabel
  }

  if (timeLabel && timeZoneLabel) {
    return `${dateLabel} at ${timeLabel} (${timeZoneLabel})`
  }

  if (timeLabel) {
    return `${dateLabel} at ${timeLabel}`
  }

  return `${dateLabel} (${timeZoneLabel})`
}

export function extractYouTubeVideoId(youtubeUrl: string | undefined): string | null {
  return extractYouTubeVideoIdFromUrl(youtubeUrl)
}
